/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Vekn_Id_RequiredInputs */



/**
* | output |
* | --- |
* | "Player must have a VEKN ID" |
*
* @param {Err_Tournament_Vekn_Id_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_vekn_id_required = /** @type {((inputs?: Err_Tournament_Vekn_Id_RequiredInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Vekn_Id_RequiredInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le joueur doit avoir un VEKN ID")
	if (locale === "es") return /** @type {LocalizedString} */ ("El jugador debe tener un ID VEKN")
	if (locale === "pt") return /** @type {LocalizedString} */ ("O jogador deve ter um VEKN ID")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il giocatore deve avere un VEKN ID")
	return /** @type {LocalizedString} */ ("Player must have a VEKN ID")
});